import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"

export const BannerSkeleton = [
    {
        span: 24,
        height: "252px",
        classes: "alignCenter marginTop-24",
    },
]

const OfferDetailSkeleton = [
    {
        height: "486px",
        classes: "justifyBetween marginBoth-40",
        columns: [
            {
                height: "486px",
                rows: [
                    { span: 12, height: "220px" },
                    { span: 12, height: "134px", classes: "marginTop-8" },
                    { span: 12, height: "90px", classes: "marginTop-16" },
                ],
            },
            {
                height: "300px",
                rows: [
                    { span: 12, height: "184px" },
                    { span: 12, height: "100px", classes: "marginTop-16" },
                ],
            },
        ],
    },
]

const OfferDetailPageSkeleton = () => {
    return (
        <>
            <Skeleton config={BannerSkeleton} />
            <Skeleton config={OfferDetailSkeleton} />
        </>
    )
}
export default OfferDetailPageSkeleton
